import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const ButtonStyled = styled(Button)(() => ({
  minWidth: 'unset',
  opacity: 0,
  maxWidth: 0,
  overflow: 'hidden',
  flexShrink: 0,
  transition: 'opacity 200ms ease-in-out, max-width 200ms ease-in-out',
  height: '15px',
  ':hover': {
    background: 'none',
  },
  '&:focus-visible': {
    opacity: 1,
    maxWidth: '60px',
  },
}));

type CopyButtonProps = {
  isCopied: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  copyLabel: string;
  copiedLabel: string;
  'data-testid'?: string;
};

export const CopyButton = ({ isCopied, onClick, copyLabel, copiedLabel, ...rest }: CopyButtonProps) => (
  <ButtonStyled
    className="copyBtn"
    size="small"
    variant="text"
    onClick={onClick}
    sx={{ color: isCopied ? '#4caf50' : 'rgba(0, 0, 0, 0.54)' }}
    {...rest}
  >
    <span aria-live="polite">{isCopied ? copiedLabel : copyLabel}</span>
  </ButtonStyled>
);
